export default "__VITE_ASSET__DkUnD2eG__"